import { NgModule } from '@angular/core';
import { provideConfig } from '../../../core/config/config-providers';

@NgModule({
  providers: [
    provideConfig({
      api: {
        endpoints: {
            transaction: 'transaction/${transactionId}',
            transactionRefund: 'transaction/${transactionId}/refund',
            transactionAdjust: 'transaction/${transactionId}/adjust',
            transactionPurchase: 'transaction/purchase',
            transactionSale: 'transaction/sale',
            transactionOnetimePay: 'transaction/newSale',
            transactions: 'transactions',
            transactionsForBatch: 'transactions',
            transactionsByCustomerId: 'transactions',
            transactionsList: 'transactions/list',
            transactionsListOpen: 'transactions/open',
            transactionsListClosed: 'transactions/closed',
            transactionsListPreauthorized: 'transactions/preauthorized',
            transactionsListFailed: 'transactions/declined',
            transactionsListBatches: 'transactions/batches',
            transactionPreauth: 'transaction/preauthorize',
            transactionCompletePreauth: 'transaction/${transactionId}/complete',
            flashpay: 'flashpay',
            flashpayParseInvoice: 'flashpay/parse-invoice',
            flashpayParseInvoiceBatch: 'flashpay/parse-invoice-batch',
            flashpayById: 'flashpay/${flashpayId}',
            flashpayByLink: { 
              path: 'flashpay/link/${linkid}',
              auth: false

            },
            flashpayPayment: {
              path: 'flashpay/link/${linkid}/payment',
              auth: false,
            },
            flashpayAttachment: {
              path: 'flashpay/link/${linkid}/attachment/${attachmentId}',
              auth: false,
            },
            // Advanced FlashPay — several invoices in one link.
            customerFlashpay: 'customers/${customerId}/flashpay',
            flashpayPaymentMethods: {
              path: 'flashpay/link/${linkid}/payment-methods',
              auth: false,
            },
            flashpayQuote: {
              path: 'flashpay/link/${linkid}/quote',
              auth: false,
            },
            flashpayInvoicesPayment: {
              path: 'flashpay/link/${linkid}/invoices/payment',
              auth: false,
            },
            batches: 'batches',
            batchForceSettle: 'batch/${batchId}/route/${routeId}/settle',
            reportsEngineGenerate: 'reports/engine/${reportType}/generate',
            receipt: 'transaction/${transactionId}/receipt',
            transactionFailureGuidance: 'transaction/${transactionId}/failure-guidance',
            validatePayment: 'validateCard',
            freelyBinLookup: 'systems/lookup/bin/${number}',
            
            // Request endpoints
            requestsList: 'requests',
            requestsListByType: 'requests/type',
            requestsListByStatus: 'requests/status',
            requestsListPending: 'requests/pending',
            request: 'request/${requestId}',
            requestApprove: 'request/${requestId}/approve',
            requestReject: 'request/${requestId}/reject',
            requestResend: 'request/${requestId}/resend',
            
            // Specific request type endpoints
            flashpayRequests: 'requests/flashpay',
            selfOnboardRequests: 'requests/self-onboard',
            customerUpdateRequests: 'requests/customer-update',
            paymentUpdateRequests: 'requests/payment-update',
            addPaymentRequests: 'requests/add-payment',
            advancedOnboardRequests: 'requests/advanced-onboard',

            // Payment History (FreelyPayments table)
            paymentsHistory: 'payments/history',
            // What the Source filter offers — the sources this profile holds.
            paymentsSources: 'payments/sources',
            paymentsHistoryDetail: 'payments/${freelyPaymentId}/detail',
            // Voids the payment's transaction and runs FTE's void cascade.
            paymentVoid: 'payments/${freelyPaymentId}/void',
            // Moving which documents a payment applied to.
            paymentAdjustApplication: 'payments/${freelyPaymentId}/adjust-application',
            paymentAdjustApplicationPreview:
              'payments/${freelyPaymentId}/adjust-application/preview',
            paymentLedgerCandidates: 'payments/${freelyPaymentId}/ledger-candidates',
            // Quick Pay: resolve the typed customer/invoice numbers, and take the one-time charge.
            quickPayLookup: 'quick-pay/lookup',
            quickPaySale: 'transaction/quick-pay',
          },
        }
      })
  ],
})

export class ConfigModule { }

